import React from 'react';
import { VehicleDetailsStore } from '../../_flux/stores/vehicle_details_store';
import { VehicleDetails } from '../../_flux/components/vehicle_details/vehicle_details';
import { handleView } from '../handle_view';

const stores = {
    state: VehicleDetailsStore,
};

const render = ({ state }, options) => (
    <VehicleDetails
        productType={options.productType}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);

